import React from "react";
import { LiaAngleLeftSolid, LiaAngleRightSolid } from "react-icons/lia";

const UserPagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <div className="flex gap-2 items-center p-4 justify-center md:mt-[50px] mt-[20px]">
      {/* Prev */}
      <button
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
        className={`rounded border w-[40px] h-[40px] flex justify-center items-center ${
          currentPage === 1
            ? "text-black border-[#BEBEBE] bg-white"
            : "hover:bg-gray-100 border-[#BEBEBE]"
        }`}
      >
        <LiaAngleLeftSolid />
      </button>

      {/* Page Numbers */}
      {pages.map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && setCurrentPage(page)}
          className={`rounded border text-base font-medium w-[40px] h-[40px] flex justify-center items-center ${
            page === "..."
              ? "cursor-default border-[#BEBEBE] text-black"
              : page === currentPage
              ? "bg-[#FFF3EF] text-[#FFA808] border-[#FFA808] font-bold"
              : "hover:bg-gray-100 border-[#BEBEBE]"
          }`}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}

      {/* Next */}
      <button
        onClick={() =>
          setCurrentPage((prev) => Math.min(prev + 1, totalPages))
        }
        disabled={currentPage === totalPages}
        className={`rounded border w-[40px] h-[40px] flex justify-center items-center ${
          currentPage === totalPages
            ? "text-black border-[#BEBEBE] bg-white"
            : "hover:bg-gray-100 border-[#BEBEBE]"
        }`}
      >
        <LiaAngleRightSolid />
      </button>
    </div>
  );
};

export default UserPagination;
